var map = {
	"./components/ApiWidget.vue": 9040,
	"./components/ButtonSelectorWidget.vue": 9965,
	"./components/Captcha.vue": 5465,
	"./components/ChartLegend.vue": 227,
	"./components/ChartWidget.vue": 2990,
	"./components/CompanySelectorWidget.vue": 4072,
	"./components/ContactDetailsWidget.vue": 8900,
	"./components/DataTable.vue": 3300,
	"./components/DataTableBody.vue": 5377,
	"./components/DataTableFooter.vue": 873,
	"./components/DataTableHeader.vue": 103,
	"./components/DatePicker.vue": 8274,
	"./components/Flash.vue": 9643,
	"./components/FooterWidget.vue": 2688,
	"./components/ImageSliderComponent.vue": 9095,
	"./components/InvestorSelectorWidget.vue": 6755,
	"./components/InvisibleSelectorWidget.vue": 5313,
	"./components/Loading.vue": 8433,
	"./components/ProgressBar.vue": 8146,
	"./components/RiskProfilerWidget.vue": 2502,
	"./components/RiskRatedReportWidget.vue": 9033,
	"./components/ScaleSelectorWidget.vue": 9380,
	"./components/SchemeSelectorWidget.vue": 6292,
	"./components/SearchStringSelectorWidget.vue": 1338,
	"./components/SelectSelectorWidget.vue": 1672,
	"./components/SelectorWidget.vue": 1946,
	"./components/TableWidget.vue": 4043,
	"./components/TextExtended.vue": 3026,
	"./components/TextWidget.vue": 1208,
	"./components/ToggleSelectorWidget.vue": 1278,
	"./components/UserSelectorWidget.vue": 358,
	"./components/VisibleSelectorWidget.vue": 9635,
	"./components/Widget.vue": 3799,
	"./components/WidgetDescription.vue": 6765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5763;